import { StepNavigationSwitch } from '../../atoms/step-navigation-switch';
import { SelectTerminalGenericNavigation } from './navigation/select-terminal-generic-navigation';
import { SelectTerminalStepNavigationProps } from './select-terminal.types';

export const SelectTerminalNavigationSwitch = ({ body }: SelectTerminalStepNavigationProps) => {
  return <StepNavigationSwitch body={body} generic={SelectTerminalGenericNavigation} />;
};
